import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { type AccessorialHistoryCharge } from '../domain/QuoteAccessorial'
import { getAccessorialsHistory } from '../use-cases/getAccessorialsHistory'

type State = {
  accessorialsHistory?: Array<AccessorialHistoryCharge>
  accessorialsHistoryStatus: RequestStatus
}

const initialState = {
  accessorialsHistoryStatus: RequestStatus.Initial,
}

export function useAccessorialsHistory() {
  const [{ accessorialsHistory, accessorialsHistoryStatus }, setAccessorialsHistoryState] =
    useState<State>(initialState)

  const fetchAccessorialsHistory = useCallback(
    async (carrierId: number, abortController?: AbortController) => {
      try {
        setAccessorialsHistoryState({
          accessorialsHistory: undefined,
          accessorialsHistoryStatus: RequestStatus.Pending,
        })

        const accessorialsHistoryResult = await getAccessorialsHistory(carrierId, abortController)

        setAccessorialsHistoryState(previous => ({
          ...previous,
          accessorialsHistory: accessorialsHistoryResult,
          accessorialsHistoryStatus: RequestStatus.Done,
        }))
      } catch (error) {
        if (!abortController?.signal.aborted) {
          setAccessorialsHistoryState(previous => ({
            ...previous,
            accessorialsHistoryStatus: RequestStatus.Error,
          }))
        }
      }
    },
    []
  )

  return {
    accessorialsHistory,
    accessorialsHistoryStatus,
    fetchAccessorialsHistory,
  }
}
